import Actividad from "./Actividad";
export default Actividad;